import clsx from 'clsx';
import React from 'react';

import { useUpgradeModal } from '@/hooks/useUpgradeModal';
import { useUserPermission } from '@/lib/auth';

type LockedFeatureOverlayProps = {
  children: React.ReactNode;
  className?: string;
  dimmed?: boolean;
  rounded?: boolean;
  onClick?: () => void;
};

export const LockedFeatureOverlay = ({
  children,
  className,
  dimmed = true,
  rounded = true,
  onClick,
}: LockedFeatureOverlayProps) => {
  const { isLoading, isOnlyBasicLicense } = useUserPermission();
  const { open } = useUpgradeModal();

  // Basicユーザー以外にはロック表示もモーダルも出さない
  if (!isOnlyBasicLicense || isLoading) return null;

  const handleActivate = (event?: React.SyntheticEvent) => {
    event?.preventDefault();
    event?.stopPropagation();
    onClick?.();
    open();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleActivate(e);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
      className={clsx(
        'group relative cursor-pointer text-left outline-none transition',
        className
      )}
    >
      <div
        className={clsx(
          'pointer-events-none transition',
          dimmed ? 'opacity-60 group-hover:opacity-70' : 'opacity-100',
          rounded && 'rounded-lg'
        )}
      >
        {children}
      </div>
    </div>
  );
};
